module.exports = __webpack_public_path__ + "assets/img/Instagram.ab03ec5b.png";